module.exports = __webpack_public_path__ + "img/robot2.png";